import { list } from 'postcss';
import { gsap, ScrollTrigger, SplitText, ScrollSmoother, scrollSmootherInstance } from '../globals/gsap';

class Prinzip {
	constructor($el) {
		this.$el = $el;
		this.sectionCount = $el.data('count');
		this.$progress = this.$el.find('[data-prinzip="progress"]');
    this.$slides = this.$el.find('[data-prinzip="slide"]');
    this.$titles = this.$el.find('[data-prinzip="title"]');
    this.$pictures = this.$el.find('[data-prinzip="picture"]');
		this.maxProgress = this.$progress.attr('stroke-dasharray');
    this.activeSection = 0;
		this.init();
	}

	init = () => {
    // split text words this.$title
    
    // this.$sections.each((i, el) => {
    //   const splitText = new SplitText($(el).find('[data-prinzip="title"]'), { type: 'words', wordsClass: 'word' });
    //   // wrap each word in a span
    //   splitText.words.forEach((word,index) => {
    //     // add index to data-index attribute
    //     const $word = $(word);
    //     $word.attr('data-index', index);
    //     $word.attr('data-word', word.textContent);
    //   });
    // });

    
    // ScrollTrigger.create({
    //   trigger: this.$el,
    //   pin: true,
    //   pinSpacer: true,
    //   end: `+=${100 * (this.sectionCount - 1)}%`,
    //   markers: true,
    //   onUpdate: self => {
    //     const progress = self.progress;
		// 		const offset = this.maxProgress - progress * this.maxProgress;
		// 		this.$progress.css('stroke-dashoffset', offset);

    //     // check which section is active
    //     let activeSection = Math.floor(progress * this.sectionCount);
    //     activeSection = gsap.utils.clamp(0, this.sectionCount - 1, activeSection);

    //     if (activeSection !== this.activeSection) {
    //       this.$sections.removeClass('active');
    //       this.activeSection = activeSection;
    //       this.$sections[this.activeSection].classList.add('active');
    //     }
    //   },
    // })

     this.$titles.each((i, el) => {
      const splitText = new SplitText($(el), { type: 'words', wordsClass: 'word' });
      // wrap each word in a span
      splitText.words.forEach((word,index) => {
        // add index to data-index attribute
        const $word = $(word);
        $word.attr('data-index', index);
        $word.attr('data-word', word.textContent);
      });
    });

    // this.$slides.addClass('initted');

    ScrollTrigger.create({
      trigger: this.$el,
      pin: true,
      pinSpacing: true,
      end: `+=${100 * (this.sectionCount - 1)}%`,
      markers: false,
      onUpdate: self => {
        const progress = self.progress;
        const offset = this.maxProgress - progress * this.maxProgress;
				this.$progress.css('stroke-dashoffset', offset);

        let activeSection = Math.floor(progress * this.sectionCount);
        activeSection = gsap.utils.clamp(0, this.sectionCount - 1, activeSection);
        
        if (activeSection !== this.activeSection) {
          this.$slides.removeClass('active');
          this.$pictures.removeClass('active');
          this.activeSection = activeSection;
          this.$slides[this.activeSection].classList.add('active');
          this.$pictures[this.activeSection].classList.add('active');
        }
      },
    });
	};
}

export default Prinzip;
